// ABOUTME: Chip of one workflow state: its label, with the color and icon set on the state.
// ABOUTME: Shared by the custom-page widgets and the data tables so a status looks the same everywhere.

import { Chip } from '@ds/coolshop';
import { resolveIcon } from '@src/_new/modules/custom-pages/utils/resolveIcon';

import type { WorkflowDefinition } from '../api/workflowApi';
import { useWorkflowLabels } from '../hooks/useWorkflowLabels';

interface WorkflowStateChipProps {
    workflow: WorkflowDefinition | null | undefined;
    stateCode: string;
}

export function WorkflowStateChip({ workflow, stateCode }: WorkflowStateChipProps) {
    const { stateLabel } = useWorkflowLabels(workflow);
    const state = workflow?.states.find(s => s.code === stateCode);
    return (
        <Chip
            size="small"
            color={state?.color ?? 'default'}
            icon={state?.icon ? resolveIcon(state.icon) : undefined}
            label={stateLabel(stateCode)}
        />
    );
}
